import { toast } from "sonner";
import { API_ENDPOINTS, HTTP_METHODS } from "../config/api";
import { BaseApiService, ApiResponse } from "./baseApi";

// RM Dashboard DTOs
export interface RMBranchInventoryDto {
  branchId: number;
  branchName: string;
  branchCode: string;
  totalQuantity: number;
  totalValue: number;
}

export interface RMCategoryInventoryDto {
  categoryId: number;
  categoryName: string;
  quantity: number;
  totalQuantity?: number;
  totalValue: number;
}

export interface RMSupplierInventoryDto {
  supplierId: number | null;
  supplierName: string;
  quantity?: number;
  totalQuantity: number;
  value?: number;
  totalValue: number;
}

export interface RMAgedInventoryDto {
  itemName: string;
  heatNo: string;
  quantity: number;
  value: number;
  grnDate: string;
  receiveDate?: string;
  grnNumber?: string;
  branchId?: number;
  branchCode?: string;
  branchName?: string;
}

export interface RMTopItemDto {
  rawItemId: number;
  itemName: string;
  rawItemSku: string;
  totalQuantity: number;
  totalValue: number;
}

export interface RMDashboardData {
  branchInventory: RMBranchInventoryDto[];
  categoryInventory: RMCategoryInventoryDto[];
  supplierInventory: RMSupplierInventoryDto[];
  agedInventory: RMAgedInventoryDto[];
  topItemsByQuantity: RMTopItemDto[];
  topItemsByValue: RMTopItemDto[];
}

// RM Dashboard API Service
class RMDashboardApiService extends BaseApiService {
  
  // Get RM dashboard data
  async getRMDashboardData(branchId?: number): Promise<ApiResponse<RMDashboardData>> {
    try {
      const data = await this.makeRequest<RMDashboardData>(
        API_ENDPOINTS.RM_DASHBOARD.DATA(branchId),
        { method: HTTP_METHODS.GET }
      );
      
      return {
        success: true,
        message: 'RM dashboard data fetched successfully',
        data: data
      };
    } catch (error) {
      // console.error('RMDashboardApiService: Error fetching RM dashboard data:', error);
      toast.error('Failed to fetch RM dashboard data');
      throw error;
    }
  }

  // Get aged RAW MATERIAL inventory (older than `months`, default 6)
  async getRMAgedInventory(branchId?: number, months?: number): Promise<ApiResponse<RMAgedInventoryDto[]>> {
    try {
      const data = await this.makeRequest<RMAgedInventoryDto[]>(
        API_ENDPOINTS.RM_DASHBOARD.AGED_INVENTORY(branchId, months),
        { method: HTTP_METHODS.GET }
      );

      return {
        success: true,
        message: 'RM aged inventory fetched successfully',
        data,
      };
    } catch (error) {
      // console.error('RMDashboardApiService: Error fetching aged inventory:', error);
      toast.error('Failed to fetch aged RM inventory');
      throw error;
    }
  }
}

export const rmDashboardApiService = new RMDashboardApiService();

